import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3mkjnsw8r: FaireProductEntity = {
  token: "p_b3mkjnsw8r",
  type: "product",
  name: "Mineral Wash Cap Sleeve Midi Dress",
  brandToken: "b_1q5tgi4unu",
  brandName: "Double Zero",
  imageUrl:
    "https://cdn.faire.com/fastly/10ba1787b4d4c75f502f37777f7b578bf9cc743af66cc27637f4fc008d23bb19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/349de32e09c7b76bbf486945c2a2e12435afe5e01d90f0992a6e38a0b4b8c083.jpeg",
    "https://cdn.faire.com/fastly/6eb29dc95383d98b3e2c1919a0912670e58f26f6310b5ff0c3b36ee20ed6fb9c.jpeg",
    "https://cdn.faire.com/fastly/d4c1a417769c06bfcc47c86daab521364c2b344d972b689c5d6f9ad1b00fa26c.jpeg",
    "https://cdn.faire.com/fastly/7109adc6ec7015ee6b662d37ba29c426685a447855f60b492e2d334bee794829.jpeg",
    "https://cdn.faire.com/fastly/a68ca5fc66182efa2246a60e675f0dbea8c58cf2c358b9937130d4411f76dd58.jpeg",
    "https://cdn.faire.com/fastly/d6e7242146295586006a81e8823e297be884e94f3b8a08f399706bf92c5f518b.jpeg",
    "https://cdn.faire.com/fastly/1130e3d78e53b9f9a9346c06c85e8a0d1f3e44aaa12df8a4c5919a312d703c99.jpeg",
    "https://cdn.faire.com/fastly/ab7fcd207cdee617ae60061b2c43c2e9601e1c3f145ef1f7718b5ec0fd01eac8.jpeg",
    "https://cdn.faire.com/fastly/bd9b2d9d8c5dff15e5ad902bd82b34cfa7e86eb72b062aacf2630bb50d6d5134.jpeg",
    "https://cdn.faire.com/fastly/f64dd5f7c5e062605359800f2af1caca8539100afe6312b9b6793778ce10fdc9.jpeg",
    "https://cdn.faire.com/fastly/d898cf9c05716c3d711b8fc2029bb99560e53ef443a39340249b34e22649766f.jpeg",
    "https://cdn.faire.com/fastly/07d2b01d546f27c32c6ddb35b7b24ef1135b9ff78c9958b834d0bcdc93c8ad36.jpeg",
    "https://cdn.faire.com/fastly/28472753d02ae942222763c43c8bd7ff55fd9f8bba360e055a8c072c3a140d11.jpeg",
    "https://cdn.faire.com/fastly/cdf69fdaf9918e69af13d958def64e0329be8d6e29854a8cbcfd33d7fbbb3365.jpeg",
    "https://cdn.faire.com/fastly/d2dcbb07f6a03d61636b3dd7d1a650191e3c6a43ba4cb9a8e3ba69a62d56122c.jpeg",
    "https://cdn.faire.com/fastly/93b140d5d365b1752360fbf2b916c72113b7497caeef7879acb99593eb65a48b.jpeg",
    "https://cdn.faire.com/fastly/5c3fcea8eb9d9abba6846a27f3ac1d1a5217d7f4691af78202548633cafb2d56.jpeg",
    "https://cdn.faire.com/fastly/5ef0ff85b49f3b8046ffd9dd17fcab8f0f4a1ddc4f20b34b98f2b0d9026d8836.jpeg",
    "https://cdn.faire.com/fastly/da31372220ce105d3aa35130b251ff6d1aa3ff684f6de8385b18ce912a0e20c1.jpeg",
    "https://cdn.faire.com/fastly/14aa819ae50031f81372f09eb3545017ffeca437671c5672157747e5ae25176f.jpeg",
    "https://cdn.faire.com/fastly/abdff34cade1d619d3316390680a6b89934e96eb032d809413ae3ca3b8c68e87.jpeg",
    "https://cdn.faire.com/fastly/15168dc4c6e69b8ff0a52525d4ad3011bfca9379b4e6a3f16cecb4f4b403c558.jpeg",
    "https://cdn.faire.com/fastly/02df6fd02300a2c73eaedcc4d7d404cdc0634c83164f5e10da7de30907273ca3.jpeg",
    "https://cdn.faire.com/fastly/74e5c993b35c89dd4653bf992f4d2893a5be3f00147a39796877702547410a03.jpeg",
    "https://cdn.faire.com/fastly/037ce4229a4d4ec7bd191aaea81b220f4bd2057cb94a5d55b0286024aebc0be4.jpeg",
    "https://cdn.faire.com/fastly/01086c8d3799b54b1d0fbeca1ab0e561959ee74118bd9f84e65ba0fa8c69e98e.jpeg",
    "https://cdn.faire.com/fastly/8dd3787957c09b3a3f5f95fbd67719b948eb4d63bb10c32d07e853f6f1d20b0f.jpeg",
    "https://cdn.faire.com/fastly/54d6cacd2d616d2721bccab1cea2abfb2a05959c2f071548c219828af6e7de46.jpeg",
    "https://cdn.faire.com/fastly/f4ace87b7ea7e1f16eec81852aba25fdcb9e0569d27e86dc6a6f6e955036264b.jpeg",
    "https://cdn.faire.com/fastly/4187841c0d6c0e513d3231edc5c387a557400a80aaf112ebe1c0a35ca15673a1.jpeg",
    "https://cdn.faire.com/fastly/1585f8e6995126315b3756d72b28d7e75eacbfce46b6aa1e691a3edd0a8b4f1e.jpeg",
    "https://cdn.faire.com/fastly/6b5acfd4c107260b70a3db2d76160e86f47a97af38e8138bf4366609d9e80292.jpeg",
    "https://cdn.faire.com/fastly/909054cf3c9be6f9b6b1177bd7d4c3f2f8d9aedb9baf9df6ed265c132c2d5d63.jpeg",
    "https://cdn.faire.com/fastly/cf2c8ff0b566b88befa4ca703be6993b1b599b8c0901fba6c63b6a115624eca5.jpeg",
    "https://cdn.faire.com/fastly/a13e72b70a986608ac1cf0acddd0fabf916645c1bad75a556c6d6d7f71071a27.jpeg",
    "https://cdn.faire.com/fastly/49f1d7eeeef34337889e48355e6d91cf128d7bd2eca04f2b66a4d3d519d35b22.jpeg",
    "https://cdn.faire.com/fastly/ac6e2cd54a9f990b0b34575d338c36e15a277f3199a6427c7da45b17e0934d9b.jpeg",
  ],
  priceDollars: 10.95,
  description:
    '• Style No.: DZ26A049_1\n\nThis essential oversized fit midi dress is crafted from soft, breathable cotton, featuring a mineral wash finish for a lived-in texture and rich, garment dyed hues. The design includes a crew neckline, slightly extended cap sleeves, functional side-seam pockets, and side slits. Pair with ankle boots and a bold belt for effortless style.\n\n• 100% Cotton\n\n• Model is 5\' 8" tall, 32" chest, 25" waist, 35" hips and wearing a size small\n\n• Imported. Designed in the USA',
  tags: [],
  msrpDollars: 21.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:34.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
